import styled, { css, DefaultTheme, StyledComponent } from 'styled-components'
import { ButtonUnstyled, Dropdown, SelectInput, Text } from '@sketch/components'
import { ReactComponent as ResetIcon } from '@sketch/icons/clockwise-arrow-circle-16'

export const StyledDropdownHeader = styled(Dropdown.Header)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 20px;
  pointer-events: auto;
`

export const IconButton = styled(ButtonUnstyled)`
  cursor: pointer;
`

export const StyledResetIcon = styled(ResetIcon)<{ $active: boolean }>`
  width: 16px;
  height: 16px;
  color: ${({ $active, theme }) =>
    $active
      ? theme.colors.foreground.secondary.A
      : theme.colors.state.disabled};
`

export const ToggleWrapper = styled(Text.Div).attrs({
  textStyle: 'copy.tertiary.standard.D',
})`
  width: 74px;
  padding: 8px 8px 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: pointer;
`

export const StyledSelectInput: StyledComponent<
  typeof SelectInput,
  DefaultTheme,
  {},
  never
> = styled(SelectInput)(
  ({ theme }) => css`
    border-left: 1px solid ${theme.colors.border.B};
  `
)
